import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ItinerarioFiltroDto, ItinerarioRespuestaDto, ItinerarioDetalleDto } from '@opb-workspace/shared';

@Injectable({
  providedIn: 'root'
})
export class ItinerarioService {
  private apiUrl = `${environment.apiUrl}/v1/itinerarios`;

  constructor(private http: HttpClient) { }

  search(filters: ItinerarioFiltroDto): Observable<ItinerarioRespuestaDto> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      const value = filters[key as keyof ItinerarioFiltroDto];
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, value.toString());
      }
    });

    return this.http.get<ItinerarioRespuestaDto>(this.apiUrl, { params });
  }

  getDetail(id: number, pol?: string, pod?: string): Observable<ItinerarioDetalleDto> {
    let params = new HttpParams();
    if (pol) {
      params = params.set('pol', pol);
    }
    if (pod) {
      params = params.set('pod', pod);
    }
    return this.http.get<ItinerarioDetalleDto>(`${this.apiUrl}/${id}`, { params });
  }

  downloadPdf(id: number, pol?: string, pod?: string): Observable<Blob> {
    let params = new HttpParams();
    if (pol) {
      params = params.set('pol', pol);
    }
    if (pod) {
      params = params.set('pod', pod);
    }
    return this.http.get(`${this.apiUrl}/${id}/pdf`, { params, responseType: 'blob' });
  }

  getPorts(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/filters/ports`);
  }

  getPolPorts(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/filters/pol-ports`);
  }

  getPodPorts(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/filters/pod-ports`);
  }

  getCarriers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/filters/carriers`);
  }

  /**
   * Export itinerarios to Excel with current filters
   */
  exportExcel(filters: ItinerarioFiltroDto): Observable<Blob> {
    let params = new HttpParams();
    Object.keys(filters).forEach(key => {
      const value = filters[key as keyof ItinerarioFiltroDto];
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, value.toString());
      }
    });

    return this.http.get(`${this.apiUrl}/export-excel`, {
      params,
      responseType: 'blob'
    });
  }
}
